import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import AdminPage from "../../components/AdminPage";
import TableComponent from "../../components/adminTableComponent";
import DeleteModalContent from "../../components/DeleteModalContent/DeleteModalContent";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { SpecificView } from "../../components/SpecificView/SpecificView";
import { loadDegrees } from "../Degrees/loadData";
import { loadInterests } from "../Interests/loadData";
import { loadSkills } from "../Skills/loadData";
import { AddSkillsAndMore } from "./addSkills&More";
import { loadLookupsList, loadLookupsTypes } from "./loadData";
import { lookupListHeaders } from "./tableHeaders";

const SkillsAndMore = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [lookupsList, setLookupsList] = useState([]);
  const [lookupsTypes, setLookupsTypes] = useState([]);
  const [opened, setOpened] = useState(false);
  const [update, setUpdate] = useState(false);

  const [viewModalState, setViewModalState] = useState(false);
  const [viewModalData, setViewModalData] = useState({});
  const [interests, setInterests] = useState([]);
  const [skills, setSkills] = useState([]);
  const [editData, setEditData] = useState({});
  const [deleteData, setDeleteData] = useState({});
  const [deleteModalState, setDeleteModalState] = useState(false);
  const [editModalState, setEditModalState] = useState(false);

  useEffect(() => {
    loadLookupsList(setLoading).then(setLookupsList);
    loadLookupsTypes(setLoading).then(setLookupsTypes);
    loadInterests(setLoading).then(setInterests);
    loadSkills(setLoading).then(setSkills);
  }, [location.pathname, update]);

  const filteredLookupsList = lookupsList?.filter(
    (lookup) => lookup.lookupType === "languages"
  );
  console.log("filteredLookupsList", filteredLookupsList);
  let newLookupsTypes = ["skill", "interest"];
  const filteredLookupsTypes = lookupsTypes?.filter(
    (lookupType) => lookupType === "languages"
  );
  filteredLookupsTypes.push(...newLookupsTypes);
  console.log("OUR FILTERED LOOKUPS TYPES", filteredLookupsTypes);
  console.log("OUR FILTERED LOOKUPS", lookupsTypes);
  const allSkills = skills?.map((skill) => ({
    lookupName: skill.skillName,
    _id: skill._id,
    lookupDescription: skill.skillDescription,
    createdDate: skill.createdDate,
    state: skill.state,

    lookupType: "skill",
  }));
  const allMajors = interests?.map((interest) => ({
    lookupName: interest.interestName,
    _id: interest._id,
    lookupDescription: interest.interestDescription,
    createdDate: interest.createdDate,
    state: interest.state,

    lookupType: "interest",
  }));
  const allLookups = [...filteredLookupsList, ...allSkills, ...allMajors];
  allLookups.map((lookup, index) => {
    lookup.id = index + 1;
  });
  let url = "";
  if (deleteData?.lookupType === "skill") {
    url = `skill/deleteSkill/${deleteData?._id}`;
  } else if (deleteData?.lookupType === "interest") {
    url = `interest/deleteInterest/${deleteData?._id}`;
  } else if (
    deleteData?.lookupType !== "interest" &&
    deleteData?.lookupType !== "skill"
  ) {
    url = `lookup/deleteLookup/${deleteData?._id}`;
  }
  return (
    <AdminPage title={"Skills & More"}>
      <ModalWrapper
        opened={viewModalState}
        setOpened={setViewModalState}
        title={"Skills & Details"}
        InternalComponent={
          <SpecificView
            name={viewModalData?.lookupName}
            type={viewModalData?.lookupType}
            date={viewModalData?.createdDate}
            status={viewModalData?.state}
          />
        }
      />
      <ModalWrapper
        opened={deleteModalState}
        setOpened={setDeleteModalState}
        title={"Delete Skills & More Essential"}
        InternalComponent={
          <DeleteModalContent
            route={url}
            type={"Skills & More Essentials"}
            setUpdate={setUpdate}
            setOpened={setDeleteModalState}
            setLoading={setLoading}
          />
        }
      />
      <AddSkillsAndMore
        opened={opened}
        setOpened={setOpened}
        setUpdate={setUpdate}
        lookupsTypes={filteredLookupsTypes}
        editData={editData}
        setEditData={setEditData}
        setEditModalState={setEditModalState}
        editModalState={editModalState}
        setLoading={setLoading}
      />
      <LoaderWrapper loading={loading}>
        <TableComponent
          headCells={lookupListHeaders}
          rowData={allLookups}
          opened={opened}
          setOpened={setOpened}
          showAddButton={true}
          setViewModalState={setViewModalState}
          setViewModalData={setViewModalData}
          setEditData={setEditData}
          setEditModalState={setEditModalState}
          setDeleteData={setDeleteData}
          setDeleteModalState={setDeleteModalState}
        />
      </LoaderWrapper>
    </AdminPage>
  );
};

export default SkillsAndMore;
